import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import { BranchManagementScreen } from './BranchManagement';
import { AddBranchScreen } from './BranchManagement/Add';
import { BranchMappingScreen } from './BranchManagement/BranchMapping';
import { PosManagementScreen } from './BranchManagement/PosManagement';
import { PosStep1Screen } from './BranchManagement/PosManagement/activatePos/step1';
import { PosStep2Screen } from './BranchManagement/PosManagement/activatePos/step2';
import { PosStep3Screen } from './BranchManagement/PosManagement/activatePos/step3';
import { PosStep4Screen } from './BranchManagement/PosManagement/activatePos/step4';
import { FoodCategoryScreen } from './FoodCategory';
import { AddFoodCategoryScreen } from './FoodCategory/Add';
import { FoodMenuScreen } from './FoodMenu';
import { AddMenuScreen } from './FoodMenu/AddEditMenuScreen';
import { MainScreen } from './Main';
import { ReportScreen } from './Report';
import { UserManagementScreen } from './UserManagement';
import { AddUserScreen } from './UserManagement/Add';
import { VatAddressScreen } from './VatAddress';
import { AddVatAddressScreen } from './VatAddress/Add';
import { ManageEmailScreen } from './Report/ManageEmail';
import { AuthHelper } from '../../auth/auth-helper';
import { BUSINESS_TYPE } from '../main-constant';
import { MartCategoryScreen } from './MartCategory';
import { AddMartCategoryScreen } from './MartCategory/Add';
import { MartProductScreen } from './MartProduct';
import { AddMartProductScreen } from './MartProduct/Add';
import { DeviceManagementScreen } from './DeviceManagement';
import { InvitationScreen } from './Invitation';
import ModifierGroupScreen from './ModifierGroup';
import ModifierGroupDetailScreen from './ModifierGroup/ModifierGroupDetail';
import ModifierGroupFormScreen from './ModifierGroup/ModifierGroupForm';
import ModifierItemScreen from './ModifierItem';
import { FoodCategoryDetailScreen } from './FoodCategory/Detail';

const routes = [
  {
    path: '',
    component: MainScreen,
    exact: true,
  },
  {
    path: 'branchmanagement',
    component: BranchManagementScreen,
    exact: true,
  },
  {
    path: 'branchmanagement/assignvat',
    component: BranchMappingScreen,
  },
  {
    path: 'addbranch',
    component: AddBranchScreen,
  },
  {
    path: 'usermanagement',
    component: UserManagementScreen,
  },
  {
    path: 'adduser',
    component: AddUserScreen,
  },
  {
    path: 'foodmenu',
    component: FoodMenuScreen,
    pathBusinessTypeId: BUSINESS_TYPE.FOOD
  },
  {
    path: 'vataddress',
    component: VatAddressScreen,
  },
  {
    path: 'addvataddress',
    component: AddVatAddressScreen,
  },
    {
    path: 'foodcategory/:foodCategoryId',
    component: FoodCategoryDetailScreen,
    pathBusinessTypeId: BUSINESS_TYPE.FOOD
  },
  {
    path: 'foodcategory',
    component: FoodCategoryScreen,
    pathBusinessTypeId: BUSINESS_TYPE.FOOD
  },
  {
    path: 'addmenu',
    component: AddMenuScreen,
    pathBusinessTypeId: BUSINESS_TYPE.FOOD
  },
  {
    path: 'addfoodcategory',
    component: AddFoodCategoryScreen,
    pathBusinessTypeId: BUSINESS_TYPE.FOOD
  },
  {
    path: 'report',
    component: ReportScreen,
    exact: true,
  },
  {
    path: 'report/manage_email',
    component: ManageEmailScreen,
  },
  {
    path: 'posmanagement',
    component: PosManagementScreen,
    exact: true,
    pathBusinessTypeId: BUSINESS_TYPE.FOOD
  },
  {
    path: 'posmanagement/step1',
    component: PosStep1Screen,
    pathBusinessTypeId: BUSINESS_TYPE.FOOD
  },
  {
    path: 'posmanagement/step2',
    component: PosStep2Screen,
    pathBusinessTypeId: BUSINESS_TYPE.FOOD
  },
  {
    path: 'posmanagement/step3',
    component: PosStep3Screen,
    pathBusinessTypeId: BUSINESS_TYPE.FOOD
  },
  {
    path: 'posmanagement/step4',
    component: PosStep4Screen,
    pathBusinessTypeId: BUSINESS_TYPE.FOOD
  },
  {
    path: 'martcategory',
    component: MartCategoryScreen,
    pathBusinessTypeId: BUSINESS_TYPE.MART,
  },
  {
    path: 'addmartcategory',
    component: AddMartCategoryScreen,
    pathBusinessTypeId: BUSINESS_TYPE.MART,
  },
  {
    path: 'martproduct',
    component: MartProductScreen,
    pathBusinessTypeId: BUSINESS_TYPE.MART,
  },
  {
    path: 'addmartproduct',
    component: AddMartProductScreen,
    pathBusinessTypeId: BUSINESS_TYPE.MART
  },
  {
    path: 'devicemanagement',
    component: DeviceManagementScreen,
    exact: true
  },
  {
    path: 'gp/invitation',
    component: InvitationScreen,
    exact: true
  },
  {
    path: 'modifier-group',
    component: ModifierGroupScreen,
    exact: true,
  },
  {
    path: 'modifier-group/add',
    component: ModifierGroupFormScreen,
    exact: true,
  },
  {
    path: 'modifier-group/:id/edit',
    component: ModifierGroupFormScreen,
  },
  {
    path: 'modifier-group/:id',
    component: ModifierGroupDetailScreen,
  },
  {
    path: 'modifier-item',
    component: ModifierItemScreen
  }
];

export default () => {
  const { url } = useRouteMatch();
  const businessTypeId = AuthHelper.getBusinessTypeId();

  return (
    <Switch>
      {routes.map((route, idx) => (
        <Route exact={route.exact} key={idx} path={`${url}/${route.path}`}>
          {route.pathBusinessTypeId ? businessTypeId === route.pathBusinessTypeId ? <route.component /> :
            <Redirect to={{ pathname: '/main', }} /> : <route.component />}
        </Route>
      ))}
      <Redirect
        to={{
          pathname: '/main',
        }}
      />
    </Switch>
  );
}
